import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Outlink",
  "use": "Outlink-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Outlink\"><path d=\"M10.929 4.5a1.071 1.071 0 0 1 0 2.143H6.643v10.714h10.714v-4.286a1.071 1.071 0 0 1 2.143 0v4.286c0 1.184-.96 2.143-2.143 2.143H6.643A2.143 2.143 0 0 1 4.5 17.357V6.643c0-1.184.96-2.143 2.143-2.143h4.286Zm8.016 0c.296 0 .536.24.536.536v4.232a.536.536 0 0 1-.915.378l-1.358-1.358-4.764 4.768a1.071 1.071 0 1 1-1.515-1.515l4.763-4.768-1.358-1.358a.536.536 0 0 1 .38-.915h4.23Z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol